import React from 'react';
import { library } from '@fortawesome/fontawesome-svg-core';
import { faPlay } from '@fortawesome/free-solid-svg-icons/faPlay';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { ConfigTitle } from './config-title';
import '../styles/intro.scss';
import { ContactButton } from '../../shared/components/contact-button/contact-button';
import { isEnter } from '../../shared/util/functions';

library.add(faPlay);

interface Props {
	onPress: () => void;
}

export const Intro: React.FunctionComponent<Props> = props => {
	return (
		<section className={'limit-width'}>
			<ConfigTitle title={'Wie gut sehen Sie?'} subtitle={'Testen Sie sich selbst.'} />
			<p className={'intro__description standard-text'}>
				Nutzen Sie diesen <strong>Online-Seh-Check</strong>, um eine erste
				Einschätzung Ihrer Sehschärfe zu bekommen.
				Bitte beachten Sie, dass das Ergebnis nur einen groben Richtwert
				darstellt und der Online-Sehtest einen <strong>professionellen Sehtest nicht ersetzt</strong>.
			</p>

			<div tabIndex={0} className={'intro__button'} onKeyPress={evt => isEnter(evt) && props.onPress()} onClick={props.onPress}>
				<div className={'intro__button__symbol'}><FontAwesomeIcon icon={'play'} /></div>
				<div className={'intro__button__text'}>Sehtest starten</div>
			</div>
			<div >
				<ContactButton/>
			</div>
		</section >
	);
};
